<mat-dialog-content>
    <img [src]="imageUrl" alt="">
</mat-dialog-content>
